import(/* webpackMode: "eager" */ "/codebuild/output/src2164447088/src/github.com/bitstone/offerz-nextjs/src/app/global-error.tsx");
